import { Connection } from "./Connection.model";

export class BlobConnection extends Connection
{
    public blobStorageAccount!: string
    public blobStorageAccountSecret!: string
    public blobContainer!: string
    public fileFormat!: string
    public columnDelimiter!: string
}